export const Logo = () => (
  <>
    <circle cx="12" cy="12" r="10" fill="#00CE8E" />
    <path
      d="M8 18H11.0225V6H8V18ZM14.4076 18H18L13.2677 10.6854L13.2159 12.4888L17.8791 6H14.6494L10.6943 11.7135L10.7116 11.9831L14.4076 18Z"
      fill="url(#kalshiBrandLogoGradient)"
    />
    <defs>
      <linearGradient id="kalshiBrandLogoGradient" x1="13" y1="6" x2="13" y2="18" gradientUnits="userSpaceOnUse">
        <stop stopColor="#012E25" />
        <stop offset="1" stopColor="#000101" />
      </linearGradient>
    </defs>
  </>
);
